export const FC_PHONE_DISPLAY = "(619) 431-3070";
export const FC_PHONE_HREF = "tel:+16194313070";
export const FC_WEBSITE = "http://www.fernandezcharters.com";
export const FC_MAP_URL = "https://maps.app.goo.gl/vsSjYGwAX9WhLF7f6";

export const FC_SPECS = [
  { label: "Hull", value: "Boston Whaler 285 Conquest" },
  { label: "Power", value: "Twin Honda BF 250 outboards" },
  { label: "Range", value: "300+ miles" },
  { label: "Main bait tank", value: "70 gallon midship" },
  { label: "Aux bait tank", value: "34 gallon" },
  { label: "Electronics", value: "Latest sonar, radar & GPS" },
  { label: "Comfort", value: "Full head, shower, galley" },
  { label: "Capacity", value: "6 guests — 4 is the sweet spot" },
];

export const FC_SPEC_GROUPS = [
  {
    title: "Hull & power",
    rows: [
      { label: "Vessel", value: "Kate Elizabeth" },
      { label: "Hull", value: "Boston Whaler 285 Conquest" },
      { label: "Engines", value: "Twin Honda BF 250 four-stroke outboards" },
      { label: "Cruise range", value: "300+ miles" },
      { label: "Ride", value: "Unsinkable deep-V hull — stable, dry, and fast" },
    ],
  },
  {
    title: "Fishing systems",
    rows: [
      { label: "Main bait tank", value: "70 gallon midship, pressurized" },
      { label: "Aux bait tank", value: "34 gallon" },
      { label: "Tower", value: "Tuna tower for spotting fish and paddies" },
      { label: "Rod storage", value: "Rocket launchers, gunwale and tower holders" },
      { label: "Deck", value: "Open, walk-around fishing platform" },
    ],
  },
  {
    title: "Electronics & safety",
    rows: [
      { label: "Sonar", value: "Latest-generation sounder for marking bait and tuna" },
      { label: "Radar & GPS", value: "Full radar, chartplotter and autopilot" },
      { label: "Communications", value: "VHF and offshore comms" },
      { label: "Safety", value: "Coast Guard inspected gear, EPIRB and life raft ready" },
    ],
  },
  {
    title: "Comfort",
    rows: [
      { label: "Head", value: "Full enclosed head with shower" },
      { label: "Galley", value: "Onboard galley and cabin seating" },
      { label: "Capacity", value: "Up to 6 guests — 4 is the sweet spot" },
      { label: "Shade", value: "Hardtop with full canvas" },
    ],
  },
];
